import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import { Alert, Select, StackView } from 'localmed-core';

import { Scaleup } from '../../legacyCore/Transitions';

const ReasonForVisitSelect = (props) => {
  const { selectedItem } = props;
  return (
    <StackView spacing="sm">
      <Select {...props} items={sortBy(props.items, 'display')} />
      {selectedItem && selectedItem.description && (
        <Scaleup key={selectedItem.id} in>
          <Alert fontSize="sm">{selectedItem.description}</Alert>
        </Scaleup>
      )}
    </StackView>
  );
};

ReasonForVisitSelect.propTypes = {
  ...Select.propTypes,
  placeholder: PropTypes.string,
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string,
  }),
};

ReasonForVisitSelect.defaultProps = {
  placeholder: 'Select a reason…',
};

export default ReasonForVisitSelect;
